import React, { useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import Header from "../../organisms/header";
import Loading from "../../atoms/loading";
import T from "../../atoms/translate";
import GenericModal from "../../organisms/modal";
import { t } from "../../../utils/utils";

const Project = (props) => {
  const [videoIsOpen, setVideoIsOpen] = useState(false);
  return (
    <div>
      <Header />
      <Container className="mt-4">
        <h1 className="text-primary">
          <T i18nKey="misProyectos" />
        </h1>
        <hr />
        <Row>
          {props.loading ? (
            <Col xs="auto" className="mx-auto">
              <Loading />
            </Col>
          ) : (
            props.projectContent
          )}
        </Row>
        <Row>
          <Col xs="12">
            <hr />
            <h1 className="text-center text-primary font-size-13 mb-3">
              <T i18nKey="miraElVideoAntes" />
            </h1>
          </Col>
          <Col xs="12" md="5" lg="4" className="mx-auto mb-3">
            <Button
              color="primary"
              onClick={() => setVideoIsOpen(true)}
              className="font-size-11"
              block
            >
              <T i18nKey="verVideo" />
            </Button>
          </Col>
        </Row>
      </Container>
      <GenericModal
        id="getting-started-video"
        isOpen={videoIsOpen}
        size="lg"
        title={t("verVideo")}
        closeButtonText={t("cerrar")}
        closeAction={() => setVideoIsOpen(false)}
      >
        <iframe
          title="Bindbox video tutorial"
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/vaLVIaTgUJ8"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </GenericModal>
    </div>
  );
};

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

export default Project;
